<template>
    <main-content with_go_back_bar>
        <div>
            <settlements-report-filter
                :action="filterAction"
                :exportExcel="exportToExcel"
            >
            </settlements-report-filter>
            <div>
                <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
            </div>
        </div>
    </main-content>
</template>

<script>

import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import settlementsColumns from './datatable/settlements-report-columns'
import settlementsReportFilter from './components/settlements-report-filter'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import {mapGetters} from "vuex";
import store from '@/store'
import axios from "axios";
import { KTApp } from '@/plugins/core/app'
import toastr from "toastr";
import { i18n } from '@/plugins/i18n'

export default {
    name: "subsets_settlements_report",
    components: {
        mainContent,
        'settlements-report-filter': settlementsReportFilter
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path(`marketing/subsets-settlements-report`),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            }
                        }
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: settlementsColumns
            }
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        exportToExcel(e, query){
            let btn = $('#export_settlements_btn')
            KTApp.progress(btn)

            this.query = query
            axios({
                url: ApiUrl.path(`marketing/export-subsets-settlements-report`),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then((response) => {
                KTApp.unprogress(btn)
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'settlements.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
                KTApp.unprogress(btn)
            })
        },
    },
}

</script>